import api from '@/libs/axiosInstance';
import { useCurrentBrandQuery } from '@/hooks/queries/use-current-brand-query';
import type { ApiResponse, UgcAttentionResponse } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import { COLLABS_PATH, collabKeys } from './collab-keys';

/**
 * What the brand has to do on its UGC collabs, computed by the server: the
 * « Décisions sur 14 jours » calendar of the UGC page and the badge of the UGC
 * menu entry. One query for both, so the badge never counts a decision the
 * calendar does not show. Every collab decision invalidates it with the list.
 */
export const useUgcAttentionQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { data: brand } = useCurrentBrandQuery();
  const brandId = brand?.id ?? '';

  return useQuery<UgcAttentionResponse, Error>({
    queryKey: collabKeys.ugcAttention(brandId),
    queryFn: async () => {
      const { data } = await api.get<ApiResponse<UgcAttentionResponse>>(
        `${COLLABS_PATH}/ugc/attention`
      );
      return data.data as UgcAttentionResponse;
    },
    enabled: enabled && !!brandId,
  });
};
